// A control the person's role cannot use (brand v2, D121): it stays where it would be, dimmed,
// with a lock, and says why when pressed. Nothing disappears silently, nothing ends in a 403.
import { useId, useState } from 'react'
import { useI18n } from '../i18n'
import { Icon } from './icons'

export type LockedBy = 'admin' | 'owner'

export function Locked({
  label,
  by = 'admin',
  className = 'btn',
  name,
}: {
  label: string
  /** Who can: owners and admins, or owners alone. */
  by?: LockedBy
  /** The button it stands in for (`btn sm`, `btn solid`…); the lock dims it either way. */
  className?: string
  /** An accessible name when `label` repeats in a list ("Revoke" on every row). */
  name?: string
}) {
  const { t } = useI18n()
  const [open, setOpen] = useState(false)
  const id = useId()
  const reason = by === 'owner' ? t('locked.owner') : t('locked.admin')
  return (
    <span className="locked">
      <button
        type="button"
        className={`${className.replace(/\b(solid|danger)\b/g, '').trim()} is-locked`}
        aria-disabled="true"
        aria-expanded={open}
        aria-controls={id}
        aria-label={name ? `${name}. ${reason}` : undefined}
        onClick={() => setOpen(!open)}
      >
        <Icon name="lock" small />
        {label}
      </button>
      {open ? (
        <span id={id} role="note" className="locked-why">
          {reason}
        </span>
      ) : null}
    </span>
  )
}
